<template>
  <div class="container">
    <div @click="goback()">
      <div class="navi">
          <span class="icon-arrow-left"></span>
      </div>
    </div>
    
    <div class="title">订单详情</div>

    <transition name="fade">
        <div id="loadingToast" v-show="isSending">
            <div class="weui-mask_transparent"></div>
            <div class="weui-toast">
                <i class="weui-loading weui-icon_toast"></i>
                <p class="weui-toast__content">正在获取订单</p>
            </div>
        </div>
    </transition>
  </div>
</template>

<script>
import qs from 'qs'

export default {
  name: 'order-detail-redirect',
  data () {
    return {
      isSending:false,
    }
  },
  created: function () {
    this.redirect();
  },
  methods: {
    redirect(){
      // if(this.$route.query.type){
      if(0){
        switch (this.$route.query.type) {
          case "1550735905":
              this.$router.replace('/move/order-detail?id=' + this.$route.query.id);
            break;
          case "1550735979":
              this.$router.replace('/baggage/order-detail?id=' + this.$route.query.id);
            break;
          case "1550735960":
              this.$router.replace('/clean/order-detail?id=' + this.$route.query.id);
            break;
          //仓储-假期特惠
          case "1550735973":
              this.$router.replace('/storage/order-detail?id=' + this.$route.query.id);
            break;
          //大扫除
          case "1550735948":
              this.$router.replace('/cleanex/order-detail?id=' + this.$route.query.id);
            break;
          //短租屋
          case "1550735961":
              this.$router.replace('/cleanex/order-detail?id=' + this.$route.query.id);
            break;
          //专项
          case "1550735962":
              this.$router.replace('/cleanex/order-detail?id=' + this.$route.query.id);
            break;
          //周期性
          case "1550735971":
              this.$router.replace('/cleanex/order-detail?id=' + this.$route.query.id);
            break;
          case "1550735974":
              this.$router.replace('/warehouse/order-detail?id=' + this.$route.query.id);
            break;
          case "1550735981":
              this.$router.replace('/pest/order-detail?id=' + this.$route.query.id);
            break;
          case "1550735980":
              this.$router.replace('/misc/order-detail?id=' + this.$route.query.id);
            break;
          case "1550735986":
              this.$router.replace('/organization/order-detail?id=' + this.$route.query.id);
            break;
          default:
            console.log("no-type");
        }
      }
      else{
        if(this.isSending){
          return false;
        }
        else{
          let dataObject={};
          let that = this;
          this.isSending = true;
          dataObject.order_number = this.$route.query.id;
          dataObject.token = localStorage.token;

          this.axios.post(this.apiURL()+'/Order/getOrderAttr', qs.stringify(dataObject))
          .then(function (response) {
            if(response.data.error_code==0){
              that.orderDetail = response.data.data;
              if(that.orderDetail.type_id == "1550735905"){
                  that.$router.push('/move/order-detail?id=' + that.$route.query.id);
              }
              if(that.orderDetail.type_id == "1550735979"){
                  that.$router.push('/baggage/order-detail?id=' + that.$route.query.id);
              }
              if(that.orderDetail.type_id == "1550735960"){
                  that.$router.push('/clean/order-detail?id=' + that.$route.query.id);
              }
              if(that.orderDetail.type_id == "1550735973"){
                  if(that.orderDetail.level==2){
                    that.$router.replace('/storage/order-detail-sub?id=' + that.$route.query.id);
                    return false;
                  }
                  else{
                    that.$router.push('/storage/order-detail?id=' + that.$route.query.id);
                  }
              }
              if(that.orderDetail.type_id == "1550735948"){
                  that.$router.push('/cleanex/order-detail?id=' + that.$route.query.id);
              }
              if(that.orderDetail.type_id == "1550735961"){
                  that.$router.push('/cleanex/order-detail?id=' + that.$route.query.id);
              }
              if(that.orderDetail.type_id == "1550735962"){
                  that.$router.push('/cleanex/order-detail?id=' + that.$route.query.id);
              }
              if(that.orderDetail.type_id == "1550735971"){
                  that.$router.push('/cleanex/order-detail?id=' + that.$route.query.id);
              }
              if(that.orderDetail.type_id == "1550735974"){
                  if(that.orderDetail.level==2){
                    that.$router.replace('/warehouse/order-detail-sub?id=' + that.$route.query.id);
                    return false;
                  }
                  else{
                    that.$router.push('/warehouse/order-detail?id=' + that.$route.query.id);
                  }
              }
              if(that.orderDetail.type_id == "1550735980"){
                  that.$router.push('/misc/order-detail?id=' + that.$route.query.id);
              }
              if(that.orderDetail.type_id == "1550735986"){
                  that.$router.push('/organization/order-detail?id=' + that.$route.query.id);
              }
              if(that.orderDetail.type_id == "1550735981"){
                  that.$router.push('/pest/order-detail?id=' + that.$route.query.id);
              }
            }
            else{
              if(!that.checkLogin()){
                that.$router.push('/login?ordercallback=' + that.$route.query.id);
              }
              else{
                that.$router.push('/order');
              }
              that.isSending=false;
            }
          })
          .catch(function (error) {
              console.log(error)
              alert("订单获取失败，请检查网络并尝试刷新页面")
              that.isSending=false;
          });
        }
      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";


</style>



// WEBPACK FOOTER //
// src/pages/order/order-detail.vue